import React from 'react'
import { motion } from "motion/react"
import { variants, useRevealInitial } from "../lib/motion"
import ExperienceCardData from "../Data/ExperienceCardData"

// Bold metrics like "50%", "1.3%" or "1100ms to 120ms" so they pop when skimming.
const METRIC = /(\d+(?:\.\d+)?(?:%|ms)(?:\s+to\s+\d+(?:\.\d+)?(?:%|ms))?)/g;

function withBoldMetrics(text) {
  return text.split(METRIC).map((part, i) =>
    i % 2 === 1 ? <strong key={i} className="font-semibold text-mist-100">{part}</strong> : part
  );
}

function Role({ role }) {
  return (
    <div className="rounded-md border border-ink-800 bg-ink-950 p-5">
      <div className="mb-3 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1">
        <h4 className="font-semibold text-mist-100">{role.job_title}</h4>
        <p className="font-mono text-xs text-mist-500">{role.timeline}</p>
      </div>
      {role.summary && <p className="mb-3 text-mist-100">{role.summary}</p>}
      <ul className="mb-4 list-disc space-y-1.5 pl-5 text-sm leading-relaxed text-mist-500 marker:text-mist-500">
        {role.highlights.map((highlight) => (
          <li key={highlight}>{withBoldMetrics(highlight)}</li>
        ))}
      </ul>
      <ul className="flex flex-wrap gap-2" aria-label="Skills">
        {role.tags.map((tag) => (
          <li
            key={tag}
            className="rounded-full border border-ink-800 px-2.5 py-0.5 font-mono text-xs text-mist-500"
          >
            {tag}
          </li>
        ))}
      </ul>
    </div>
  );
}

function ExperienceList() {
  return (
    <motion.div
      className="mx-auto flex max-w-2xl flex-col gap-6 px-6 py-16"
      initial={useRevealInitial("hidden")}
      whileInView="visible"
      viewport={{ once: true, margin: "-80px" }}
      variants={variants.staggerContainer}
    >
      {ExperienceCardData.map((item) => (
        <motion.section
          key={item.company}
          id={item.company}
          variants={variants.fadeUp}
          className="rounded-lg border border-ink-800 bg-ink-900 p-6"
        >
          <div className="mb-5 flex items-center gap-4">
            <div className="flex h-14 w-14 shrink-0 items-center justify-center rounded-md bg-chip p-2">
              <img src={item.logo} alt="" className="h-full w-full object-contain" />
            </div>
            <div className="min-w-0">
              <h3 className="text-lg font-semibold text-mist-100">{item.company}</h3>
              <p className="font-mono text-xs text-mist-500">{item.location}</p>
            </div>
          </div>
          <div className="flex flex-col gap-4">
            {item.roles.map((role) => (
              <Role key={role.job_title} role={role} />
            ))}
          </div>
        </motion.section>
      ))}
    </motion.div>
  )
}

export default ExperienceList
